import classNames from 'classnames';
import * as React from 'react';

import './RequiredMark.css';

interface RequiredMarkProps {
    cls?: string;
}

export class RequiredMark extends React.PureComponent<RequiredMarkProps> {
    render() {
        return (
            <span className={classNames('required-mark', this.props.cls)}>
                *
            </span>
        );
    }
}
